module.exports = __webpack_public_path__ + "img/pic1.4dc826e6.png";